import { referralQueryKeys as e } from "./useReferralQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { referralApi as n } from "@maat/api-main";
//#region src/partners/useReferralLinkInfoQuery.ts
var r = (r) => t({
	queryKey: e.linkInfo(r),
	queryFn: () => n.linkInfo(r),
	enabled: !!r,
	retry: !1
});
//#endregion
export { r as useReferralLinkInfoQuery };
